<template>
    <div class="continer">
        <background>
            <div>
                <div class="content">
                    <div class="img">
                        <img src="@/assets/images/busImage/print.png" style="width:100%;height:100%"/>
                    </div>
                    <div class="scan-btn" @click="printVoucher">打印分隔页</div>
                </div>
            </div>
        </background>
        <pageHeader ref="pageHeader" :isCustom="printLoadingDialogVisible || resetLoading"></pageHeader>
        <tipsDialog tipsMessage="打印机缺纸，请联系管理员补充纸张，在此过程中可先退出原始凭证，或继续等待"
                     :dialogVisible="noPaperDialogVisible"
                     @handleClose="waitPrint">
            <div class="btn-group">
                <div class="cancle-btn" @click="waitPrint">继续等待</div>
                <div class="confirm-btn" @click="exitTicket">退出原始凭证</div>
            </div>       
        </tipsDialog>
        <errorDialog :errorMessage="errorMessage" :dialogVisible="errorDialogVisible">
            <div class="text-btn" @click="exitTicket">退出原始凭证</div>
        </errorDialog>
        <tipsDialog tipsMessage="打印中，请稍等..."
                     :dialogVisible="printLoadingDialogVisible">
        </tipsDialog>
        <tipsDialog tipsMessage="正在取消打印任务，请稍等..."
                     :dialogVisible="resetLoading">
        </tipsDialog>
        <!-- 退票流程 -->
        <exitTicketProcess ref="exitTicketProcess" exitTitle="取出全部原始凭证后，请点击收回托盘" @dishHaveNoPaper="dishHaveNoPaper" @dishHandleFinish="dishHaveNoPaper"></exitTicketProcess>

    </div>
</template>
<script>
import background from '@/components/background'
import pageHeader from '@/components/pageHeader'
import errorDialog from '@/components/errorDialog'
import tipsDialog from '@/components/tipsDialog'
import exitTicketProcess from '@/components/exitTicketProcess'
import { downloadVoucher } from '@/api/order'
import { getCookie } from "@/utils/auth";
export default {
    components: {
        background,
        pageHeader,
        errorDialog,
        tipsDialog,
        exitTicketProcess
    },
    data(){
        return  {
            noPaperDialogVisible: false, // 缺纸
            // 其余异常
            errorMessage: '',
            errorDialogVisible: false,
            printLoadingDialogVisible: false,
            resetLoading: false
        }
    },
    computed: {
        id(){
            return this.$route.query.id || 0
        },
        orgId() {
            if(getCookie('orgInfo')){
                return +(JSON.parse(getCookie('orgInfo')).id)
            }else {
                return 0
            }
        }
    },
    destroyed(){
        this.ptr.removeEventListener("onMediaPresented");
    },
    methods: {
        printVoucher(){
            let data = {
                id: this.id,
                orgId: this.orgId
            }
            this.printLoadingDialogVisible = true
            downloadVoucher(data).then(res => {
                if(res.code === 500){
                    console.error('数据异常')
                    this.printLoadingDialogVisible = false
                }else {
                    const blob = new Blob([res.data],{type:'application/pdf'})
                    let url = URL.createObjectURL(blob)
                    let fileBase64 = 'data:application/pdf;base64,' + btoa(
                        new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                    this.printPage(fileBase64)
                }
                
            })
        },
        async printPage(fileBase64){
            this.$emit('ControlLight', 'printer_light', '500');
            let param = {};
                param.type = "pdfbase64";
                param.data = new Array();
                param.data.push(fileBase64);
                param.paper = "A4"; //纸张
                param.orientation = "auto"; //"portrait"纵向 "landscape"横向  "auto" 自动根据横纵比计算//方向 
                param.color = false; //彩色
                param.quality = "h"; //high medium low draft 
                console.log('---------开始打印')
                let result = await this.ptr.print(param);
                console.log("print:::" + JSON.stringify(result));
                if (result.result == 0) {
                    this.$emit('PlaySound','printEnd');
                    // 跳转
                    console.log('---------打印成功')
                    this.printLoadingDialogVisible = false
                    this.$router.push({
                        name: 'accountVoucher',
                        query: {
                            id: this.id
                        }
                    })
                } else if(result.result == -11) {
                    this.noPaperDialogVisible = true
                    this.printLoadingDialogVisible = false
                }else {
                    this.printLoadingDialogVisible = false
                    console.error("打印分隔页发生错误:" + result.message);
                    if(result.message){
                        this.errorMessage = `打印机内部出现${result.message},请处理此情况，并退出全部原始凭证`
                    }else{
                        this.errorMessage = `打印机内部出现异常,错误码${JSON.stringify(result)}，并退出全部原始凭证`
                    }
                    
                    this.errorDialogVisible = true
                }
        },
        exitTicket(){
            this.noPaperDialogVisible = false
            this.errorDialogVisible = false
            this.resetDevice().then(res => {
                this.$refs.exitTicketProcess.getDishHavePaper()
            }).catch(e => {
                console.log(e)
            })
        },
        waitPrint(){
            this.noPaperDialogVisible = false
            this.resetDevice()
        },
        dishHaveNoPaper(){
            this.$router.push({name: 'start'})   
        },
          // 重置收票模块
        resetDevice() {
            this.$emit('ControlLight', 'printer_light', '0');
            return new Promise( async(reslove,reject) => {
                this.resetLoading = true
                let result = await this.ptr.resetDevice();
                console.log("resetDevice:" + JSON.stringify(result));
                if(result.result == 0) {   
                    console.log("重置打印机成功"); 
                    this.resetLoading = false
                    reslove()
                } else {
                    console.error("重置打印机成功发生错误:" +  + result.message);
                    this.errorMessage = '重置打印机成功发生错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                    this.resetLoading = false
                    reject()
                }
            })
            
        },
    }
}
</script>
<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    .content {
        position: absolute;
        top: 233px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        .tips {
            font-weight: 400;
            font-size: 32px;
            color: #000000;
            letter-spacing: 2px;
            text-align: center;
        }
        .img{
            width: 456px;
            height: 456px;
            box-sizing: border-box;
            padding: 93px 0 50px 0;
            margin: 40px 0;
            background: #FAFAFA;
            border-radius: 8px;
            border: 2px solid rgba(0,0,0,0.06);
        }
        .scan-btn {
            width: 456px;
            height: 80px;
            line-height:80px;
            background: radial-gradient( 0% 141% at -1% 0%, #C62D2F 0%, #B23B34 100%);
            border-radius: 8px;
            font-weight: 400;
            font-size: 28px;
            text-align: center;
            color: #FFFFFF;
        }
    }
</style>


